"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DEFAULT_TIMEOUT = exports.ButtonTypes = void 0;
var _react = _interopRequireWildcard(require("react"));
var _starWhite = _interopRequireDefault(require("./starWhite.svg"));
require("./styles.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * This is the Button component that will be used in school-ui
 * The following are the props that can be passed to the component
 *
 * @property {String} label The label of the button (Ex: Okay, Save, etc...).
 * @property {ButtonTypes} type The type of button to be rendered.
 * @property {Function?} onClick Pass any function to be executed.
 * @property {Boolean} loading This property will set the state of button, Use this to pass state of api loading/resolved. (loading -> disabled).
 * @property {Number} customTimeout This property can be used to supply a custom timeout during which the button will be disabled.
 * @property {Boolean} disabled This property will set the state of button to be disabled.
 * @property {String} className This property will be used to pass extra classNames for the button for additional customization.
 * @property {Object} style If any, this property can be used to pass additional styles to the button.
 * @property {JSX} children If any, this property will be used to pass the children to the component.
 * @property {Boolean} stopPropagation, this property will decide whether to bubble up the event or not.
 *
 * @Note
 * 1) Each instance of the Button component must contains these props:
 *   a) Either `label` or `children` prop to render the text inside button.
 *   b) `type`: a type from ButtonTypes.
 *   c) Either `onClick` or `disabled` prop to either have a functional or disabled button.
 *
 * 2) By default a timeout period of 2 seconds is there, but user can change this via `customTimeout` prop.
 **/

//Default timeout period in milliseconds
var DEFAULT_TIMEOUT = exports.DEFAULT_TIMEOUT = 2000;

// ButtonTypes
var ButtonTypes = exports.ButtonTypes = {
  primary: "primary-cta-button",
  secondary: "secondary-cta-button",
  star: "primary-cta-button star-btn",
  custom: {
    "default": "default-cta-button",
    inline: "inline-cta-button",
    sync: "sync-cta-button"
  }
};

// Component
var Button = function Button(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? "" : _ref$label,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? "" : _ref$type,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$customTimeout = _ref.customTimeout,
    customTimeout = _ref$customTimeout === void 0 ? null : _ref$customTimeout,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$stopPropagation = _ref.stopPropagation,
    stopPropagation = _ref$stopPropagation === void 0 ? true : _ref$stopPropagation,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDisabled = _useState2[0],
    setIsDisabled = _useState2[1];
  var callAndDisable = function callAndDisable(e) {
    var callbackFunction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    var timeout = arguments.length > 2 ? arguments[2] : undefined;
    stopPropagation ? e.stopPropagation() : null;
    e.preventDefault();
    if (!isDisabled) {
      setIsDisabled(true);
      callbackFunction();
      var taskToDefer = function taskToDefer() {
        setIsDisabled(false);
      };
      setTimeout(function () {
        return taskToDefer();
      }, timeout);
    }
  };
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "".concat(type || "", " ").concat(className || "", " ").concat(className === "" && type === "" ? ButtonTypes.primary : "", " ").concat(isDisabled || loading || disabled ? 'disabled' : ''),
    style: style || {},
    onClick: function onClick(e) {
      return loading ? null : callAndDisable(e, _onClick, customTimeout ? customTimeout : DEFAULT_TIMEOUT);
    },
    "data-sentry-component": "Button",
    "data-sentry-source-file": "index.tsx"
  }, label || "", children, type === ButtonTypes.star ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "button-star-container"
  }, /*#__PURE__*/_react["default"].createElement(_starWhite["default"], null)) : null);
};
var _default = exports["default"] = Button;